import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import SoldIcon from 'react-icons/lib/fa/tag'
import MoreIcon from 'react-icons/lib/md/keyboard-arrow-right'


const Piezas = (props) => (

  <div className='piezas-list'>

    {props.data.map((elem, i) => (
        <div key={i} className="card" >
              
          <div className="card-image">
            <Link to={elem.node.fields.slug}>
              <Img
                sizes={
                  elem.node.relationships.image.relationships.imageFile.localFile
                    .childImageSharp.sizes
                }
              />           
              <span className="card-title">{elem.node.title}</span>
            </Link>  
          </div>
          
          <div 
            className="card-content">

            <p>{elem.node.field_excerpt}</p>

            {(elem.node.vendido) && <h6 className="green-text"><SoldIcon />Vendido</h6>}

          </div>
          
          <div className="card-action">
            <Link to={elem.node.fields.slug}>Ver Más <MoreIcon /></Link>
          </div>
          
        </div>
              
      )
  )}

  </div>
)

export default Piezas



// WEBPACK FOOTER //
// ./src/components/piezas.js